export default "__VITE_ASSET__e9224c7a__"